import type React from 'react';

import { type Placement } from '@floating-ui/react';
import { m } from 'framer-motion';

import MotionLazy from './MotionLazy';

// scale starts at 0.9 (not 0): at scale(0) frame ALL content has a 0×0 rect,
// so components that measure the DOM (MUI Tabs indicator etc.) report
// "not part of the document layout" — a zero-rect frame must not exist
const OPTIONS_PLACEMENT: Partial<Record<Placement, any>> = {
  'bottom-end': { opacity: 0, originX: 1, originY: 0, scale: 0.9 },
  'bottom-start': { opacity: 0, originX: 0, originY: 0, scale: 0.9 },
};
const OPTIONS = {
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, originX: 1, originY: 0, scale: 0.9 },
  initial: { opacity: 0, originX: 1, originY: 0, scale: 0.9 },
  transition: { duration: 0.3 },
};
export interface MotionFadeInProps {
  children: React.ReactNode;
  /**
   * If placement is not set, animation wont run
   */
  placement: Placement;
  className?: string;
}
const MotionDropdown = ({
  children,
  className,
  placement,
}: MotionFadeInProps) => {
  if (!placement) return null;
  return (
    <MotionLazy>
      <m.div
        initial={OPTIONS_PLACEMENT[placement]}
        transition={OPTIONS.transition}
        animate={OPTIONS.animate}
        className={className}
        exit={OPTIONS.exit}
      >
        {children}
      </m.div>
    </MotionLazy>
  );
};

export default MotionDropdown;
